import * as THREE from 'three'
import Experience from '../Experience.js'
import vertexShader   from '../../shaders/particles/vertex.glsl'
import fragmentShader from '../../shaders/particles/fragment.glsl'

/**
 * BackgroundParticles
 * ~700 ambient dust/smoke particles drifting slowly upward.
 * Distributed in a wide box around the scene; very low opacity,
 * warm parchment colour — gives depth and luxury atmosphere.
 */
export default class BackgroundParticles {
    constructor() {
        this.experience = new Experience()
        this.scene      = this.experience.scene
        this.time       = this.experience.time
        this.debug      = this.experience.debug

        this.count = 700

        this.setGeometry()
        this.setMaterial()
        this.setPoints()
        this.setDebug()
    }

    setGeometry() {
        this.geometry = new THREE.BufferGeometry()

        const positions = new Float32Array(this.count * 3)
        const aSize     = new Float32Array(this.count)
        const aSpeed    = new Float32Array(this.count)
        const aOffset   = new Float32Array(this.count)

        for (let i = 0; i < this.count; i++) {
            const i3 = i * 3
            // Spread across a wide box: X [-12, 12], Y [-12, 12], Z [-8, 8]
            positions[i3]     = (Math.random() - 0.5) * 24
            positions[i3 + 1] = (Math.random() - 0.5) * 24
            positions[i3 + 2] = (Math.random() - 0.5) * 16

            aSize[i]   = 1 + Math.random() * 2.5
            aSpeed[i]  = 0.3 + Math.random() * 0.5    // units/sec
            aOffset[i] = Math.random()                 // Y phase offset
        }

        this.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        this.geometry.setAttribute('aSize',    new THREE.BufferAttribute(aSize,    1))
        this.geometry.setAttribute('aSpeed',   new THREE.BufferAttribute(aSpeed,   1))
        this.geometry.setAttribute('aOffset',  new THREE.BufferAttribute(aOffset,  1))
    }

    setMaterial() {
        this.material = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,
            uniforms: {
                uTime: { value: 0 },
            },
            transparent:  true,
            depthWrite:   false,
            blending:     THREE.AdditiveBlending,
        })
    }

    setPoints() {
        this.points = new THREE.Points(this.geometry, this.material)
        this.scene.add(this.points)
    }

    setDebug() {
        if (!this.debug.active) return
        const folder = this.debug.ui.addFolder('BG Particles')
        folder.add(this.material, 'visible').name('Visible')
    }

    update() {
        this.material.uniforms.uTime.value = this.time.elapsed * 0.001
    }
}
